const parseEnvBoolean = (value, defaultValue = true) => {
    if (typeof value === 'boolean') return value;
    if (typeof value !== 'string') return defaultValue;

    const normalizedValue = value.trim().toLowerCase();
    if (normalizedValue === 'true') return true;
    if (normalizedValue === 'false') return false;
    return defaultValue;
};

export const isTourEnabled = () =>
    parseEnvBoolean(
        process.env.REACT_APP_SWITCH_TOUR ?? process.env.switch_tour,
        true
    );
